(function() {
	'use strict';

	/**
	 * @ngdoc service
	 * @name patternLimitation.service:PatternLimitationService
	 * 
	 * @description
	 * 
	 */
	angular.module('crewValidation').service('PatternLimitationService',
			PatternLimitationService);

	function PatternLimitationService(PatternLimitationRequestFactory,
			RemoteService, CommonMasterData) {

		var self = this;

		// store retrieved data
		var model = {
			patternLimitationSearchReq : PatternLimitationRequestFactory
					.getPatternLimitationSearchRequest(),
			patternLimitationSearchResults : null,
			patternLimitationDTO : PatternLimitationRequestFactory
					.getPatternLimitationDTO(),
			patternNames : [],
			deletePatternLimitationRequest : PatternLimitationRequestFactory
					.getPatternLimitationDeleteRequest(),
			crewTypes : [],
			addedPatternNames : []
		};
		
		self.getPatternLimitationSearchReq = function(){
			return model.patternLimitationSearchReq;
		}
		
		self.getPatternNameObjectsByPatternNameList =function(patternNameStringlist){
			model.addedPatternNames =  PatternLimitationRequestFactory
			.getFormattedPatternNames(patternNameStringlist,0);
			return setNewlyAddedFlag(model.addedPatternNames);
		}
		
		function setNewlyAddedFlag(patternNames){
			if(!!patternNames && patternNames.length>0){
				for(var i=0;i<patternNames.length;i++){
					patternNames[i].isNewlyAdded = false;
				}
			}
			return patternNames;
		}

		self.setPatternLimitationSearchRequest = function(searchCrieteria) {
			model.patternLimitationSearchReq = PatternLimitationRequestFactory
					.getFormattedPatternLimitationSearchRequest(searchCrieteria);
		}

		// search Pattern Limitation
		self.getPatternLimitations = function(successFn, errorFn) {
			RemoteService
					.getPatternLimitations(model.patternLimitationSearchReq)
					.then(
							function(response) {
								if (response.success) {
									if (!!response.list
											&& response.list.length > 0) {
										model.patternLimitationSearchResults = response.list;
									} else {
										model.patternLimitationSearchResults = [];
									}
									successFn(model.patternLimitationSearchResults);
								} else {
									errorFn(response.error);
								}
							}, function(error) {
								errorFn(error.msg[0]);
							});
		};

		// edit panel object
		self.setPatternLimitationDTO = function(selectedRowData) {
			model.patternLimitationDTO = PatternLimitationRequestFactory
					.getFormattedPatternLimitationDTO(selectedRowData);
			getCrewTypes(selectedRowData);
			// set pattern List
			return model.patternLimitationDTO;
		};

		self.getPatternLimitationDTO = function() {
			model.patternLimitationDTO = PatternLimitationRequestFactory
					.getPatternLimitationDTO();
			return model.patternLimitationDTO;
		};

		// drop down fill master data
		self.getFormattedPatternNames = function(patternNameList,index) {
			model.patternNameList = PatternLimitationRequestFactory
					.getFormattedPatternNames(patternNameList,index);
			return model.patternNameList;
		};

		// delete
		self.deletePatternLimitation = function(selectedPatternLimitation,
				successFn, errorFn) {
			model.deletePatternLimitationRequest = PatternLimitationRequestFactory
					.getFormattedPatternLimitationDeleteRequest(selectedPatternLimitation);
			RemoteService.deletePatternLimitation(
					model.deletePatternLimitationRequest).then(
					function(response) {
						successFn(response);
					}, function(error) {
						errorFn(error);
					});
		};

		// save
		self.savePatternLimitation = function(selectedPatternLimitation,
				successFn, errorFn) {
			model.savePatternLimitationRequest = PatternLimitationRequestFactory
					.getFormattedPatternLimitationSaveRequest(selectedPatternLimitation);
			RemoteService.savePatternLimitation(
					model.savePatternLimitationRequest).then(
					function(response) {
						successFn(response);
					}, function(error) {
						errorFn(error);
					});

		};

		// get master data lists
		function getCrewTypes(selectedPatternLimitation) {
			CommonMasterData.getCrewTypeList(function(crewTypes) {
				model.crewTypes = crewTypes;
				var crewTypeCode = model.patternLimitationSearchReq.crewType;
				model.patternLimitationDTO.crewType = _.find(model.crewTypes, {
					crewTypeCode : crewTypeCode
				});
				setPatternNamesByCrewType(selectedPatternLimitation);
			}, function() {
				console.log('Crew types retrieval error');
			});
		}
		;

		// get pattern Names by crew types
		function setPatternNamesByCrewType(selectedPatternLimitation) {
			if (!!selectedPatternLimitation.patternNameList
					&& selectedPatternLimitation.patternNameList.length > 0) {
				model.addedPatternNames = PatternLimitationRequestFactory
						.getFormattedPatternNames(selectedPatternLimitation.patternNameList,0);
				model.patternLimitationDTO.patternNames = model.addedPatternNames;
			}
		}
		;
	}
})();